import { useState } from "react";
import { toast } from "sonner";
import { deleteQuestion } from "../services/quizService";

/**
 * useRemoveQuestion
 * Handles deleting a question by id and managing delete state.
 * @param {object} options - { parentType: 'quiz' | 'question_bank', parentId: string|number }
 * Usage:
 *   const { deleteState, handleRemoveQuestion } = useRemoveQuestion({ parentType, parentId });
 *   handleRemoveQuestion(index, question, removeFn);
 */
const useRemoveQuestion = ({ parentType, parentId } = {}) => {
  // store error of each quiz question using thier index as key
  const [deleteState, setDeleteState] = useState({
    isDeleting: false,
    deletingQuestionIndex: null,
  });

  const handleRemoveQuestion = async (index, currentQuestion, remove) => {
    setDeleteState({
      isDeleting: true,
      deletingQuestionIndex: index,
    });

    try {
      if (currentQuestion?.id) {
        const deleteOptions = parentType === 'quiz' ? { from_quiz: parentId } : { from_bank: parentId };
        await deleteQuestion(currentQuestion.id, currentQuestion.question_type, deleteOptions);
      }
      remove(index);
      toast.success("Question deleted successfully");
    } catch (error) {
      console.error("Error deleting question:", error);
      toast.error("Something went wrong. Unable to delete question.");
    } finally {
      setDeleteState({
        isDeleting: false,
        deletingQuestionIndex: null,
      });
    }
  };

  return {
    deleteState,
    handleRemoveQuestion,
    setDeleteState,
  };
};

export default useRemoveQuestion;
